import { Star } from "lucide-react";
import { useApp } from "../context/AppContext";
import { tr } from "../i18n/translations";

export default function Testimonials({ reviews = [] }) {
  const { lang } = useApp();
  const list = reviews.length ? reviews : [];
  const loop = [...list, ...list];

  return (
    <section className="bg-ivory-200 py-20" data-testid="testimonials">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-12">
          <p className="text-xs uppercase tracking-[0.25em] text-ink/60 mb-3">Communauté</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-light tracking-tight">
            <span className="italic text-pedablue">{tr(lang, "testi_title")}</span>
          </h2>
          <div className="flex items-center gap-2 mt-4">
            {[1, 2, 3, 4, 5].map((i) => <Star key={i} size={16} className="fill-coral text-coral" />)}
            <span className="text-sm text-ink-soft ms-2">{tr(lang, "testi_sub")}</span>
          </div>
        </div>
      </div>
      <div className="overflow-hidden">
        <div className="marquee-track py-2">
          {loop.map((r, i) => (
            <div key={i} className="bg-white border border-ink/10 rounded-3xl p-6 me-5 min-w-[340px] max-w-[380px]">
              <div className="flex items-center gap-1 mb-2">
                {Array.from({ length: r.rating || 5 }).map((_, k) => (
                  <Star key={k} size={12} className="fill-coral text-coral" />
                ))}
              </div>
              <p className="text-sm leading-relaxed">« {r.text} »</p>
              <p className="text-xs text-ink-soft mt-3"><span className="font-medium text-ink">{r.author}</span> · {r.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
